import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { graphql, useStaticQuery } from 'gatsby';
import Img from 'gatsby-image';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import Modal from 'react-modal';
import '../styles/global.scss';
import Form from './Form';

const LetsTalk = ({ active, setModal }) => {
  const data = useStaticQuery(
    graphql`
      query {
        contentfulHomepage {
          banksGrid {
            file {
              url
            }
          }
        }
        contentfulFormContent {
          whyChooseNuclei
        }
        contentfulAsset(title: { eq: "Nuclei-Colored-Logo" }) {
          gatsbyImageData(quality: 100, width: 189)
        }
      }
    `
  );
  const logo = data?.contentfulAsset?.gatsbyImageData?.images?.fallback?.src;
  const bankLogos = data.contentfulHomepage;
  const whyChoose = data.contentfulFormContent.whyChooseNuclei;
  const mediaMatch = window.matchMedia('(min-width: 500px)');
  const [matches, setMatches] = useState(mediaMatch.matches);

  const customStyles = {
    overlay: {
      backgroundColor: 'rgba(0,0,0,0.8)',
      display: 'flex',
      'align-items': 'center',
    },
    content: {
      top: '56%',
      left: '50%',
      right: 'auto',
      zIndex: '1000',
      bottom: 'auto',
      maxHeight: !matches ? '75%' : '95%',
      maxWidth: !matches ? '95%' : '75%',
      marginRight: '-50%',
      transform: 'translate(-50%, -50%)',
      backgroundColor: '#f9f9f9',
    },
  };

  useEffect(() => {
    const handler = e => setMatches(e.matches);
    mediaMatch.addListener(handler);
    return () => mediaMatch.removeListener(handler);
  });

  return (
    <Modal
      closeTimeoutMS={900}
      isOpen={active.active}
      onRequestClose={() => setModal({ content: '', active: false })}
      style={customStyles}
      contentLabel='Lets Talk'
    >
      {' '}
      <FontAwesomeIcon
        onClick={() => setModal({ content: '', active: false })}
        icon={faTimes}
        style={{
          color: '#666',
          float: 'right',
          cursor: 'pointer',
        }}
      />
      <div className='columns' style={{ marginLeft: '10px' }}>
        <div
          className='column is-half is-hidden-mobile'
          style={{ backgroundColor: '#fff', paddingLeft: '15px' }}
        >
          <img src={logo} alt='hello' style={{ marginLeft: 10 }} />
          <div style={{ height: '30px', marginLeft: 10 }} />
          <h1 className='Why-Choose-Nuclei' style={{ marginLeft: 10 }}>
            Why Choose Nuclei?
          </h1>
          <ul>
            {whyChoose.map((edge, id) => (
              <li key={id} className='form-left-points'>
                • {edge}
              </li>
            ))}
          </ul>
          <h1
            className='Why-Choose-Nuclei'
            style={{ marginTop: 50, marginLeft: 10 }}
          >
            Banks that trust us
          </h1>
          <div
            className='columns is-multiline is-mobile'
            style={{ marginRight: '10px', marginTop: '10px', marginLeft: 10 }}
          >
            <div className='column'>
              <img
                src={bankLogos.banksGrid[0].file.url}
                style={{ height: '40px', marginRight: '50px' }}
                alt='icici'
              />
            </div>
            <div className='column'>
              <img
                src={bankLogos.banksGrid[2].file.url}
                style={{ height: '40px', marginRight: '50px' }}
                alt='icici'
              />
            </div>
            <div className='column'>
              <img
                src={bankLogos.banksGrid[5].file.url}
                style={{ height: '40px', marginRight: '50px' }}
                alt='icici'
              />
            </div>
          </div>
          <div
            className='columns is-mobile is-centered'
            style={{ marginTop: '25px' }}
          >
            <img
              src={bankLogos.banksGrid[3].file.url}
              style={{
                height: '40px',
                marginRight: '30px',
              }}
              alt='icici'
            />
            <img
              src={bankLogos.banksGrid[11].file.url}
              style={{
                height: '40px',
                marginRight: '50px',
                marginLeft: '50px',
              }}
              alt='icici'
            />
          </div>
        </div>
        <div
          className='column '
          style={{
            paddingRight: 0,
            marginRight: 0,
            marginLeft: 'clamp(5px, 3vw,60px)',
            backgroundColor: '#f9f9f9',
          }}
        >
          <h1
            style={{
              fontSize: 'clamp(17px,2vw,22px)',
              fontWeight: '700',
              marginTop: 0,
              color: '#131313',
              paddingTop: 0,
            }}
          >
            Interested to know more about us ?
          </h1>
          <p
            style={{
              fontFamily: 'Muli',
              marginBottom: '20px',
              maxHeight: '30px',
              fontSize: 'clamp(12px,2vw,13px)',
              maxWidth: '80%',
              color: '#484848',
            }}
          >
            Please drop in a message to connect and we shall get right back to
            you within 24 hrs
          </p>
          <Form style={!matches ? { maxWidth: '95%' } : { maxWidth: '80%' }} />
        </div>
      </div>
    </Modal>
  );
};

LetsTalk.propTypes = {
  active: PropTypes.shape({
    active: PropTypes.any,
  }),
  setModal: PropTypes.func,
};

export default LetsTalk;
